module.exports = __webpack_public_path__ + "img/icon_camera.17db658a.svg";